export default __webpack_public_path__ + "static/media/heirs-launch.b0862d92.jpeg";